import GenericContentSearch from './helpers/GenericContentSearch';

export default GenericContentSearch({
  search: {
    name: 'Reusable Content',
    type: 'Reusable',
    currentLanguageOnly: true,
  },
});
